// @flow

import * as React from 'react';

import ProcSelect from '../../ice/fields/ProcSelect';

export type SelectOption<T> = {
  label: string,
  image: string,
  value: T,
};

type Props<T> = {
  options: SelectOption<T>[],
  value: ?T,
  onSelect: T => void,
};

class ProcPizzaSelect<T> extends React.Component<Props<T>> {
  render() {
    const { options, value: originalValue, onSelect, ...rest } = this.props;
    const value = options.findIndex(option => option.value === originalValue);
    const images = options.map(option => option.image);
    const labels = options.map(option => option.label);
    const onSelected = (i: number) => {
      onSelect(options[i].value);
    };
    return (
      <ProcSelect
        {...rest}
        value={value}
        images={images}
        labels={labels}
        onSelected={onSelected}
        rootNodeId="proc-pizza-fields-root-page"
      />
    );
  }
}

export default ProcPizzaSelect;
